import { render, staticRenderFns } from "./DefaultRoutesConfirmation.vue?vue&type=template&id=16b85b8e"
import script from "./DefaultRoutesConfirmation.vue?vue&type=script&lang=js"
export * from "./DefaultRoutesConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports